<div class="more_info_outer_cont_wrapper">
	<button class="close_button" (click)="closeInfo()">
		<span class="material-symbols-outlined"> close </span>
	</button>
	<div class="more_infor_fabric_cont">
		<div class="image_and_text_container">
			<div class="image_cont">
				<img src="{{chooseMTOFabricPopupData.heroImage}}">
			</div>
			<div class="text_cont">
				<div class="text_cont_text">
					{{chooseMTOFabricPopupData.name}}
				</div>
				<div class="text_cont_price">
					{{selectedCurrency | uppercase}}  {{chooseMTOFabricPopupData.price | currencyConverter | number: '1.0-2'}} /
					{{chooseMTOFabricPopupData.unit}}
				</div>
			</div>
		</div>
	</div>
</div>
